<template>
  <material-list
   :type="2"
  ></material-list>
</template>

<script>
import materialList from "./components/planeMaterialList";
export default {
  data() {
    return {};
  },
  components: { materialList },
  methods: {},
  computed: {},
};
</script>

<style lang="less" scoped>
</style>
